import { CommonFeatureStates, EXPRESSIONS } from "./expressions";
import { mergeDeep } from "@catchupapplications/utilities";
const standard = 2;
/**
 * Für die Ordentlichkeit werden möglichst alle StylingValues für jegliche Layers hier gespeichert,
 * damit man möglichst gleiche Values für alles verwendet und keinen Mischmasch hat.
 */
export const DEFAULT_STYLING = {
    rooms: {
        height: {
            standard: standard,
            glassStandard: standard + 0.05,
            glassLow: 0.2,
            // bei allen anderen außer normalen räumen sind manchmal noch polygone innendrin
            // die krieseln hässlich (wegen der gleichen höhe und farbunterschied),
            // deshalb ist es nur provisorisch, dass diese räume ein kleines bisschen höher sind
            switchFloorRoom: standard + 0.05,
            elevatorRoom: standard + 0.05,
            stairsRoom: standard + 0.05,
            entranceRoom: 3.5,
            cafeteriaRoom: standard + 0.05,
            waitingRoom: 0.2,
            emergencyRoom: standard + 0.05,
            // areas
            waitingArea: 0.2,
            cafeteriaArea: 0.2,
            emergencyArea: 0.2,
            officeArea: standard / 3,
            // floors
            mainFloor: 0,
            sideFloor: 0,
            restrictedFloor: 0,
        },
        base: {
            entranceRoom: standard + 0.05,
        },
        opacity: {
            standardRoom: 1,
            switchFloorRoom: 0.5,
            elevatorRoom: 0.5,
            stairsRoom: 0.5,
            waitingRoom: 1,
            mainFloor: 1,
            glass: 0.4,
        },
    },
    lines: {
        opacity: {
            navigation: {
                arrows: {
                    ghosted: 0,
                },
                normal: 1,
                ghosted: 0.35,
            },
        },
        blur: {
            navigation: {
                ghosted: 20,
            },
        },
        dash: [0.1, 2],
        thickness: {
            navigation: {
                normal: {
                    line: 8,
                    halo: 14,
                },
                ghosted: {
                    line: 14,
                    halo: 14,
                },
            },
        },
    },
    symbols: {
        opacity: {
            navigation: {
                arrows: {
                    ghosted: 0,
                },
                normal: 1,
                ghosted: 0.2,
            },
        },
    },
};
// These values can and will be overwritten by externally fetched values
export let CUSTOMIZABLE_VALUES = {
    // Colors für Features auf Map
    primary: "#234854",
    secondary: "#61942f",
    background: "#757575",
    selected: "#093d73",
    text_selected: "#093d73",
    hovered: "#342854",
    special: "#342854",
    white: "#ffffff",
    shadowDark: "#404040",
    // marker auf der Map (bei selected Stuff)
    childMarker: "#d44e4e",
    childMarker_darker: "#923939",
    childMarker_ghosted: "#923939",
    poiMarker: "#2a2a2a",
    poiMarker_ghosted: "#99999966",
    // Symbol Node Types
    standardSymbol: "#393939",
    unimportantSymbol: "#6f6f6f",
    textHalo: "rgba(255,255,255,0.6)",
    einrichtung: "#07e1be",
    einrichtung_light: "#c2f1ea",
    roomText: "#44556b",
    roomText_selected: "#255fa5",
    room: "#b71e5b",
    room_light: "#404040",
    poi: "#57a418",
    poi_light: "#e8fada",
    parking: "#124b92",
    parking_light: "#c7dcf5",
    notaufnahme: "#cd0000",
    notaufnahme_light: "#ffd4d4",
    bistro: "#ec442d",
    bistro_light: "#fdd0bd",
    information: "#4336fd",
    information_light: "#bad6ff",
    taxi: "#000",
    taxi_light: "#f6e67d",
    bushaltestelle: "#1c7906",
    apotheke: "#cd0000",
    apotheke_light: "#ffd4d4",
    toilette: "#048dbf",
    toilette_light: "#b9edff",
    atm: "#1f983d",
    atm_light: "#cdeed5",
    cashier: "#146088",
    cashier_light: "#9cc9e2",
    virus: "#000000",
    virus_light: "#f3ea22",
    entrance: "#54c47b",
    entrance_light: "#ffffff",
    restricted: "#dea2a2",
    restricted_light: "#ffffff",
    // Farben für Gebäudeklassen
    building_normal: "#80919e",
    building_main: "#5d6b76",
    building_parkingGarage: "#035ca3",
    building_parkingLot: "#516e86",
    // lines der Navigationsrouten
    lineFill: "#07ceae",
    lineFill_inactive: "#b0b0b0",
    userPuck: "#7cbaea",
    userPuck_radar: "#7cbaea",
    userPuck_arc: "#7cbaea",
    userPuck_inactive: "#b0b0b0",
    lineHalo: "#07ceae",
    lineHalo_inactive: "#5d5d5d",
    ghostedHalo: "#999999",
    ghostedArrowHalo: "#7a7a7a",
    // navigation nodes
    start_node: "#333b42",
    transit_node: "#333b42",
    route_node_symbol: "#333b42",
    route_node_bg: "#333b42",
    route_node_marking: "#333b42",
    // polygontypes
    building: "#e76666",
    building_selected: "#07ceae",
    rooms: "#80919e",
    rooms_active: "#07ceae",
    outline: "#ffffff",
    hallways: "#ffffff",
    ground: "#9e9e9e",
    levelRoom: "#333b42",
    waitingRoom: "#333b42",
    elevatorRoom: "#333b42",
    stairsRoom: "#333b42",
    wcRoom: "#048dbf",
    cafeteriaRoom: "#e89e77",
    entranceRoom: "#74fca3",
    emergencyRoom: "#e76666",
    // areas
    emergencyArea: "#e76666",
    cafeteriaArea: "#e89e77",
    waitingArea: "#a5e7ca",
    officeArea: "#636E84",
    mainFloor: "#ffffff",
    sideFloor: "#eedfdf",
    restrictedFloor: "#dea2a2",
    exit: "#74fca3",
    mapboxBuildings: "#999999",
    masks: "#888888",
    // Information
    error: "#ff6969",
    warning: "#ffec63",
    info: "#8dfadf",
    success: "#06B195",
    gpsAvailable: "#06B195",
    highlight: {
        standard: "#8dfadf",
        warning: "#ffec63",
        danger: "#ff6969",
    },
    buildingPolygonColors: [],
    // default Font, welches bei allen (nicht explizit hier definierten) layern verwendet wird
    defaultMapFont: ["Open Sans Regular", "Arial Unicode MS Regular"],
    // Einrichtungen Texts
    facilityTextFont: ["Open Sans Semibold", "Arial Unicode MS Regular"],
};
/**
 * This is a freshly generated values json from the database, completely custom
 */
export let generatedMapStyleJSON;
export function setGeneratedMapStyleJSON(json) {
    generatedMapStyleJSON = json;
}
/**
 * Data that you get from the Database in form of a GeneratedMapStyleJSON can be inserted here
 * to get the correct expressions for styling the layers
 * @param styleIdArray
 * @param options.featureState If given: Checks if the given FeatureState is boolean true -> takes _active styleId.
 * Otherwise
 * @returns Case Expressions for Mapbox
 */
export const getStyleIdExpressions = (styleIdArray) => {
    // TODO: Expected at least 3 arguments, but found only 1 bug
    // the "case" Expression expects to be at least 3 values to be given, yet sometimes this can not be done
    // usually there are styleIds, in some cases nothing comes in the mapstyle, so there has to be a fallback
    //
    const insertionArray = [];
    styleIdArray === null || styleIdArray === void 0 ? void 0 : styleIdArray.forEach((v) => {
        // only check for styleId
        insertionArray.push(["==", EXPRESSIONS.styleId, v.styleId]);
        insertionArray.push(v.value);
    });
    return insertionArray;
};
/**
 * Get expressions for FeatureStates, both dependent and independent of the styleId.
 * @param styleIdArray
 * @param options
 * @returns
 */
export function getFeatureStateStyleIdExpressions(featureStateKey, styleIdArray) {
    const insertionArray = [];
    styleIdArray === null || styleIdArray === void 0 ? void 0 : styleIdArray.forEach((v) => {
        if (featureStateKey) {
            // styleId is available, featureState is boolean and true
            insertionArray.push([
                "all",
                ["==", EXPRESSIONS.styleId, v.styleId],
                ["boolean", ["feature-state", featureStateKey], false],
            ]);
            insertionArray.push(v.value);
        }
    });
    if (featureStateKey) {
        // FeatureState exists and is a not a boolean -> use the given feature-state value
        insertionArray.push([
            "all",
            ["boolean", ["to-boolean", ["feature-state", featureStateKey]], false],
            ["!", ["boolean", ["feature-state", featureStateKey], false]],
        ]);
        insertionArray.push(["feature-state", featureStateKey]);
    }
    return insertionArray;
}
/**
 * Get the default class values from the database styles. The ones where it's "class":"default"
 */
export const getDefaultValue = (classArray) => {
    let defaultValue = null;
    classArray === null || classArray === void 0 ? void 0 : classArray.forEach((c) => {
        if (c.default) {
            defaultValue = c.value;
        }
    });
    return defaultValue;
};
/**
 * Used to write fetched custom values for the layer properties.
 */
export function setJSCustomStylingValues(json) {
    // @ts-ignore
    CUSTOMIZABLE_VALUES = mergeDeep(CUSTOMIZABLE_VALUES, json);
}
export const getCaseProperties = (options) => {
    var _a, _b, _c;
    const { defaultFallback, mapStyleArray, mapStyleArray_active } = options;
    if (mapStyleArray_active) {
        return [
            "case",
            ...getFeatureStateStyleIdExpressions(CommonFeatureStates.fillColor, mapStyleArray_active),
            ...getStyleIdExpressions(mapStyleArray),
            // fallback
            (_a = getDefaultValue(mapStyleArray)) !== null && _a !== void 0 ? _a : defaultFallback,
        ];
    }
    else {
        const styleExpressions = getStyleIdExpressions(mapStyleArray);
        if (styleExpressions.length < 2) {
            // Theres not enough cases, so you only get back the default value
            return (_b = getDefaultValue(mapStyleArray)) !== null && _b !== void 0 ? _b : defaultFallback;
        }
        else {
            return [
                "case",
                ...getStyleIdExpressions(mapStyleArray),
                // fallback
                (_c = getDefaultValue(mapStyleArray)) !== null && _c !== void 0 ? _c : defaultFallback,
            ];
        }
    }
};
